import { useTranslation } from '@frontend/i18n';
import type { GetWeavePopNotificationByType, NotificationActions } from '@frontend/types';
import { formatDate } from '@frontend/design-system';
import { BaseNotificationComponentProps, BaseNotificationInner, BaseNotificationOuter } from './base';
import { DefaultNotificationBody } from './defaults/default-notification';

type Props = BaseNotificationComponentProps<GetWeavePopNotificationByType<'schedule-waitlist'>>;

export const ScheduleWaitlistNotificationComponent = ({ isHistorical, notification, emit, ...rest }: Props) => {
  const { t } = useTranslation();
  const scheduleWaitlistDateTime = formatDate(notification.payload.startTime, 'dddd MMM D, h:mm A');
  const scheduleeName = notification.payload.inviteeName;

  const actions: NotificationActions = [
    {
      label: t('View'),
      action: () => {
        emit({ action: 'view', payload: undefined }, notification);
      },
    },
  ];

  return (
    <BaseNotificationOuter
      actions={actions}
      notification={notification}
      emit={emit}
      isHistorical={isHistorical}
      {...rest}
    >
      <BaseNotificationInner
        onClose={() => emit({ action: 'ignore', payload: undefined }, notification)}
        actions={actions}
        title={t('New Waitlist')}
        body={<DefaultNotificationBody body={scheduleWaitlistDateTime} name={scheduleeName} />}
        id={notification.id}
        timestamp={notification.timestamp}
        notificationType={notification.type}
        {...rest}
      />
    </BaseNotificationOuter>
  );
};
